// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { precisionM } from 'config/constants'
import { roundToFixed } from 'helpers/reduxFormFunctions'
import { convertBetweenMandFt } from 'helpers/unitConversion'

// this is to ensure a value is in meters for API.
// v is the value we're interested in
// unitType is the unit type which v currently represents.
// unitType here is not at user level or project level
// it is tied directly to the value of v.
// if the value's already in SI, don't convert, just return as num
// NOTE - this returns a number
const valueAsMeters = (v, unitType) => (
  unitType === 'SI'
    ? roundToFixed(v, precisionM)
    : convertBetweenMandFt(v, 'SI')
)

export default valueAsMeters
